import { useSessionsList } from '@/components/layout/Navigation/sessions/side-nav-list/hooks/useSessionsList';
import { Button } from '@heidi/design-system/button';
import { FramedIcon } from '@heidi/design-system/framed-icon';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { RefreshCw } from 'lucide-react';

export const SessionsListError = () => {
  const { t } = useTranslations();

  const { onRefetchBtnClick } = useSessionsList();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-2">
      <FramedIcon size="lg" state="error" />
      <TypographyP2Bold className="text-validation-destructive">
        {t('sessions.errorLoadingSessions')}
      </TypographyP2Bold>
      <Button disableAutomaticSvgSizing size="xs" onClick={onRefetchBtnClick}>
        <RefreshCw size={12} className="min-h-3 min-w-3" />
        <span>{t('sessions.retry')}</span>
      </Button>
    </div>
  );
};
